<template>
  <v-dialog
    v-model="show"
    width="90vw"
    persistent
    :fullscreen="$vuetify.breakpoint.mobile"
  >
    <template
      v-for="(_, scopedSlotName) in $scopedSlots"
      #[scopedSlotName]="slotData"
    >
      <slot :name="scopedSlotName" v-bind="slotData" />
    </template>
    <template v-for="(_, slotName) in $slots" #[slotName]>
      <slot :name="slotName" />
    </template>
    <edit-form
      :item="item"
      :lesson-plan="lessonPlan"
      :hide-lessons="hideLessons"
      :readonly-lessons="readonlyLessons"
      :hide-terms="hideTerms"
      :readonly-terms="readonlyTerms"
      :readonly="readonly"
      :submit-api="submitApi"
      hide-view-details
      @submit="onSubmit"
      @update:item="onUpdateItem"
      @cancel="show = false"
    >
      <template #header>
        <v-card-title>
          <div>Edit Schedule {{ item.classroom.name }}</div>
          <v-spacer></v-spacer>
          <v-btn icon @click="show = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </template>
    </edit-form>
  </v-dialog>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import EditForm from '@components/ClassroomSchedule/EditForm'
export default {
  name: 'EditScheduleDialog',
  components: {
    EditForm,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      required: true,
    },
    lessonPlan: {
      type: Object,
      default: () => null,
      required: false,
    },
    hideLessons: {
      type: Boolean,
      default: false,
      required: false,
    },
    readonlyLessons: {
      type: Boolean,
      default: false,
      required: false,
    },
    hideTerms: {
      type: Boolean,
      default: false,
      required: false,
    },
    readonlyTerms: {
      type: Boolean,
      default: false,
      required: false,
    },
    readonly: {
      type: Boolean,
      default: false,
      required: false,
    },
    submitApi: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      classDateMenu: false,
      form: {
        class_date: null,
        start_time: '',
        end_time: '',
        term: null,
        month: null,
        session: null,
        lessons: [],
      },
    }
  },
  computed: {
    ...mapGetters({
      isLoading: 'classroomSchedule/isDetailLoading',
      lessonList: 'lesson/list',
      isLessonListLoading: 'lesson/isListLoading',
      categoryList: 'lessonCategory/list',
      isCategoryListLoading: 'lessonCategory/isListLoading',
    }),
    show: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  methods: {
    ...mapActions({
      updateSchedule: 'classroomSchedule/update',
      getLessonList: 'lesson/getList',
      getCategoryList: 'lessonCategory/getList',
      handleError: 'handleError',
    }),
    onSubmit(data) {
      this.$emit('submit', data)
    },
    onUpdateItem(data) {
      this.$emit('update:item', data)
    },
  },
}
</script>
